<script setup lang="ts">
import FosDialog from '@/components/ui/FosDialog.vue'
import FosButton from '@/components/ui/FosButton.vue'

defineProps<{ visible: boolean }>()

const emit = defineEmits<{
  'update:visible': [value: boolean]
  'wizard-start': []
  'quick-create': []
  manual: []
}>()

function close() {
  emit('update:visible', false)
}
</script>

<template>
  <FosDialog
    :open="visible"
    title="New Incident"
    max-width="max-w-md"
    @update:open="emit('update:visible', $event)"
  >
    <div class="flex flex-col gap-5">
      <!-- Wizard pitch -->
      <div class="bg-surface-container-low p-4 border border-primary-container/30">
        <div class="flex items-start gap-3">
          <div class="flex-1">
            <p class="font-mono text-sm font-bold text-on-surface">
              Set up your mission faster
            </p>
            <p class="font-mono text-xs text-on-surface-variant mt-1">
              The setup wizard walks you through ICS structure, subject info, and resources.
            </p>
            <span class="inline-block mt-2 font-mono text-[0.65rem] font-bold uppercase tracking-widest bg-primary-container text-white px-2 py-0.5">
              About 2 minutes
            </span>
          </div>
        </div>
        <ul class="mt-3 flex flex-col gap-1.5">
          <li
            v-for="bullet in [
              'Sets up ICS structure and subject information',
              'Any step can be skipped and filled in later',
            ]"
            :key="bullet"
            class="flex items-start gap-2 font-mono text-xs text-on-surface-variant"
          >
            <span class="material-symbols-outlined text-primary text-[14px] shrink-0 mt-0.5">check</span>
            {{ bullet }}
          </li>
        </ul>
      </div>

      <!-- Path options -->
      <div class="flex flex-col gap-2">
        <!-- Start wizard -->
        <FosButton
          class="w-full justify-start"
          @click="() => { emit('wizard-start'); close() }"
        >
          <div class="flex flex-col items-start">
            <span>Start wizard</span>
            <span class="text-[0.6rem] font-normal normal-case tracking-normal opacity-80">Guided setup in 4 steps</span>
          </div>
        </FosButton>

        <!-- Quick create -->
        <FosButton
          variant="secondary"
          class="w-full justify-start"
          @click="() => { emit('quick-create'); close() }"
        >
          <div class="flex flex-col items-start">
            <span>Quick create</span>
            <span class="text-[0.6rem] font-normal normal-case tracking-normal opacity-80">Name + type + time, launch immediately</span>
          </div>
        </FosButton>

        <!-- Manual -->
        <button
          type="button"
          class="w-full text-center py-2 font-mono text-xs text-outline hover:text-on-surface transition-colors"
          @click="() => { emit('manual'); close() }"
        >
          I'll set up manually
        </button>
      </div>
    </div>
  </FosDialog>
</template>
